import React, { useContext, useEffect } from "react";
import { SjorcraftCanvas } from "./SjorcraftCanvas";
import Toolbar from "./Toolbar";
import { Viewer } from "../../../sjorcraft3d/src/viewer";
import {
  RendererContext,
  RendererContextType,
} from "../contexts/rendererContext";
import EditorSidebar from "./EditorSidebar";
import { useDeviceSize } from "../hooks/useDeviceSize";
import { Stack } from "@mui/material";
import { useParams } from "react-router-dom";
import { UserContext } from "../contexts/userContext";

const SjorcraftEditor = () => {
  const { userId } = useParams();
  const { user } = useContext(UserContext);

  const [rendererContext, setRendererContext] =
    React.useState<RendererContextType>({});

  useEffect(() => {
    const element = document.getElementById("render_area");
    if (!element) return;

    const viewer = new Viewer(element);
    viewer.selectionTool.allowEdit(user.id === userId);
    setRendererContext({ viewer });

    return () => {
      viewer.cleanup();
      viewer.inventory.resetPoleset();
      setRendererContext({ viewer: undefined });
    };
  }, []);

  const { smDevice } = useDeviceSize();

  return (
    <RendererContext.Provider value={rendererContext}>
      <Toolbar />
      <Stack
        direction={"row"}
        sx={{
          height: "calc(100% - 4rem)",
        }}
      >
        <SjorcraftCanvas />
        {!smDevice && <EditorSidebar />}
      </Stack>
    </RendererContext.Provider>
  );
};

export default SjorcraftEditor;
